import React, {Component} from 'react';
import {observer} from "mobx-react";
import {observable, makeObservable, action, reaction, toJS} from "mobx";
import axios from "../../../utils/axios";
import Loading from "../../Loading";
import Aspect from "../Aspect";
import LazyImg from "../LazyImg";
import uid from "../../../utils/generateUid";
import webp from "../../../utils/webp";
import LazyBg from "../LazyBg";

class MyPhotosSelector extends Component {

  list={
    fetching: false,
    inited: false,
    data:{}
  };
  selected_obs=[];
  is_selected={};
  section=null;

  constructor(props) {
    super(props);

    makeObservable(this, {
      list: observable,
      section: observable,
      is_selected: observable,
      selected_obs: observable,
      setAnsweredData: action,
    });

    this.unreact=reaction(()=>{ return this.section; }, (sect)=>{
      this.loadData(sect);
    });

  }
  componentWillUnmount() {
    this.unreact();
  }
  loadData(sect) {
    this.list.fetching=true;
    axios.get(`/api/photos_selector/${sect}`).then((data)=>{
      this.setAnsweredData(data.data.answer);
    });
  }
  setAnsweredData(answer) {
    this.list.data=answer;
    this.list.fetching=false;
    this.list.inited=true;
  }
  componentDidMount() {
    if(this.props.already) {
      for(let i in this.props.already) {
        const cur=this.props.already[i];
        this.is_selected[cur.id]=1;
        this.selected_obs.push(this.props.already[i]);
      }
    }
    this.section=0;
  }
  renderSections() {
    const list = this.list.data.sections.map((data) => {
      return (
        <div key={data.id} onClick={()=>{ this.section=data.id; }} className="cell up12 splice fs14 vpadd5 hpadd10 pointer bg-w2-hover s-start">
          <div className="cell s-shrink mdi mdi-folder pright5 fs20 lh10"></div>
          <div className="cell s-auto ptop3">{data.name}</div>
        </div>
      )
    });
    return (
      <div className="up12 margin s-size-3">
        {this.list.data.cur_dir?(
          <div onClick={()=>{ this.section=this.list.data.cur_dir.section; }} className="cell up12 splice fs14 vpadd5 hpadd10 pointer bg-w2-hover">
            <div className="cell s-shrink mdi mdi-folder pright5 fs20 lh10"></div>
            <div className="cell s-auto ">..</div>
          </div>
        ):null}
        {list}
      </div>
    )
  }
  renderPhotos() {
    const list = this.list.data.photos.map((data) => {
      return (
        <div key={data.id} onClick={()=>{ this.selectPhoto(data); }} className="cell mbottom15 pointer pr">
          <Aspect className="bg-w2 pr" aspect={"3:4"}>
            <LazyBg className="pa pa-tl w100 h100" style={{backgroundPosition:'center center',backgroundSize:'contain', backgroundRepeat:'no-repeat',backgroundImage:`url('${data.preview}')`}} />
          </Aspect>
          {this.is_selected[data.id]?(
            <div className="pa pa-tl w100 h100 solid5 bo-pc1 bg-w1-op50 up12 splice">
              <div className="cell s-12 tac s-middle mdi mdi-check fs40 pc1"></div>
            </div>
          ):null}
        </div>
      )
    });
    if(list.length > 0) {
      return (
        <div className="up12 margin s-size-5 ptop20">
          {list}
        </div>
      )
    }
  }
  selectPhoto(photoOb) {
    if(!this.is_selected[photoOb.id]) {
      this.is_selected[photoOb.id]=1;
      this.selected_obs.push(photoOb);
    } else {
      delete this.is_selected[photoOb.id];
      const index=this.selected_obs.findIndex((item)=>{ return photoOb.id == item.id;  });
      this.selected_obs.splice(index, 1);
    }
  }
  render() {
    if(!this.list.inited) {
      return <Loading />
    }
    return (
      <div className=" ptop20">
        <div className="padd20 bg-w1 rad4">
          <div className="pbottom10 solid1-bottom bo-w2">
            <div className="font1 fs24">Выберите фотографии</div>
          </div>
          <div className="ofa" style={{ maxHeight: "calc(100vh - 200px)" }}>
            <div className="ofh">
              {this.renderSections()}
              {this.renderPhotos()}
            </div>
          </div>
          <div className="tar ptop20">
            <span onClick={()=>{ this.props.onCancel(); }} className="btn2"><span>Отмена</span></span>
            {this.selected_obs.length>0?(
              <span onClick={()=>{ this.props.onSelect(toJS(this.selected_obs)); }} className="btn1 mleft20"><span>Выбрать</span></span>
            ):null}
          </div>
        </div>
      </div>
    )
  }
}

export default observer(MyPhotosSelector);